import { render, staticRenderFns } from "./ProfilesPanel.vue?vue&type=template&id=8c67ccac&scoped=true"
import script from "./ProfilesPanel.vue?vue&type=script&lang=js"
export * from "./ProfilesPanel.vue?vue&type=script&lang=js"
import style0 from "./ProfilesPanel.vue?vue&type=style&index=0&id=8c67ccac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c67ccac",
  null
  
)

export default component.exports